import React from "react";
import { styles } from "./styles";
import Icon from "@jll/icon";
import AddIcon from '@material-ui/icons/Add';
import { Button, TableCell, TableRow, Typography, withStyles } from "@material-ui/core";

const AssociationDetail = (props) => {
  const { association, handleAdd, classes } = props;

  const addAssociation = () => {
    handleAdd(association);
  }

  return (
    <>
      <TableRow>
        <TableCell className={classes.fieldValue} width={250} style={{whiteSpace: 'nowrap'}}>
          <Typography component="p" variant={'body1'}>
            {association.legalStatus === "Legal Person" ?
              <Icon className="far fa-university" style={{ marginRight: 5 }} />
              : <Icon className="far fa-user" style={{ marginRight: 5 }} />
            }
              {association.name}
            </Typography>
            { association.additionalInfo && association.additionalInfo.address && association.additionalInfo.address.address_line_1 ? 
              <Typography component="span" variant="caption">{`${association.additionalInfo.address.address_line_1}, ${association.additionalInfo.address.city}`}</Typography> :
              ''
            }
            
        </TableCell>
        <TableCell className={classes.fieldValue} width={250} scope="col" align="center" style={{whiteSpace: 'nowrap'}}>
          <Typography component="p" variant={'body1'}>
            {association.additionalInfo?.sourceRole}
          </Typography>
        </TableCell>
        <TableCell className={classes.fieldValue} width={250} scope="col" align="center" style={{whiteSpace: 'nowrap'}}>
          <Typography component="p" variant={'body1'}>
            {association.associatedAs}
          </Typography>
        </TableCell>
        <TableCell className={classes.fieldValue} scope="col" align="center">
          <Button
            disableRipple
            disableElevation
            aria-label="add association"
            onClick={addAssociation}
          >
            <AddIcon />
          </Button>
        </TableCell>
      </TableRow>
    </>
  );
}

export default withStyles(styles, { withTheme: true })(AssociationDetail);